import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  paymentDetails: { order_id: any; razorpay_payment_id: any; };
  companyDetails:any={};
  bureauDetails:any={};
  // Payment failed
  public paymentFailedActions = new BehaviorSubject({paymentFailedStatus:false,paymentFailedMsg:""});
  public paymentFailedActionData = this.paymentFailedActions.asObservable();

  // Payment success
   private paymentSuccess = new BehaviorSubject<any | null>(null);
  paymentSuccess$ = this.paymentSuccess.asObservable();

  

  private razorPay = new BehaviorSubject<any | null>({});
  razorPay$ = this.razorPay.asObservable();

constructor() { }

  setrazorPaySubject(obj: any | null) {
    this.razorPay.next(obj);
  }
  setPaymentFailed(data:any) {
    console.log("LOGGGGG", data)
    this.paymentFailedActions.next(data);
}


// ✅ Add this
  setPaymentSuccess(data: any) {
    this.paymentSuccess.next(data);
  }

  // ✅ Add this
  getPaymentSuccess() {
    return this.paymentSuccess.getValue();
  }

// private _companyDetails = new BehaviorSubject<any>(null);
// companyDetails$ = this._companyDetails.asObservable();

// updateCompanyDetails(data: any) {
//   this._companyDetails.next(data);
// }

}
